import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import ServiceIntro from './components/ServiceIntro';
import Benefits from './components/Benefits';
import Pricing from './components/Pricing';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import CompanyInfo from './components/CompanyInfo';
import Footer from './components/Footer';
export function App() {
  return <div className="font-serif text-gray-800" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <ServiceIntro data-id="element-4" />
        <Benefits data-id="element-5" />
        <Pricing data-id="element-6" />
        <Testimonials data-id="element-7" />
        <FAQ data-id="element-8" />
        <CompanyInfo data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
    </div>;
}